import { render, staticRenderFns } from "./thumbnail.vue?vue&type=template&id=5857fad0"
import script from "./thumbnail.vue?vue&type=script&lang=js"
export * from "./thumbnail.vue?vue&type=script&lang=js"
import style0 from "./thumbnail.vue?vue&type=style&index=0&id=5857fad0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports